const CRYPTO_KEY =
  process.env.REACT_APP_API_CRYPTO_KEY || "YW5hc3RhY2lvLWRldi1jcnlwdG8ta2V5LWhlYmVy";

async function sha256Binary(secret: string): Promise<ArrayBuffer> {
  const data = new TextEncoder().encode(secret);
  return crypto.subtle.digest("SHA-256", data);
}

function base64ToBytes(value: string): Uint8Array {
  const binary = atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

function isEncryptedEnvelope(data: any, response: any): boolean {
  const header =
    response?.headers?.["x-api-crypto"] || response?.headers?.["X-Api-Crypto"];
  if (String(header) === "1") {
    return true;
  }
  return (
    data &&
    typeof data === "object" &&
    data.payload &&
    data.iv &&
    data.tag &&
    Object.keys(data).length === 3
  );
}

export async function decryptApiPayload(
  envelope: { payload: string; iv: string; tag: string },
  secret: string
): Promise<any> {
  const keyMaterial = await sha256Binary(secret);
  const key = await crypto.subtle.importKey(
    "raw",
    keyMaterial,
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  );

  const iv = base64ToBytes(envelope.iv);
  const tag = base64ToBytes(envelope.tag);
  const payload = base64ToBytes(envelope.payload);
  const cipherWithTag = new Uint8Array(payload.length + tag.length);
  cipherWithTag.set(payload);
  cipherWithTag.set(tag, payload.length);

  const plainBuffer = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    key,
    cipherWithTag
  );

  return JSON.parse(new TextDecoder().decode(plainBuffer));
}

export function installAxiosCryptoInterceptor(axiosInstance: any): void {
  axiosInstance.interceptors.response.use(async (response: any) => {
    const data = response.data;
    if (isEncryptedEnvelope(data, response)) {
      response.data = await decryptApiPayload(data, CRYPTO_KEY);
    }
    return response;
  });
}
